module.exports = __webpack_public_path__ + "img/AT.8ba54155.svg";